import React from 'react';
import DocPaging from '../../../view/cmn/DocPaging'

const FormPaging = (props) => {
    const { formObject } = props;
    const pagingData = formObject.paging;

    const onPageChange = (page) => {
        let action = {};
        action.actionId = "show";
        action.actionParam = {pId:page}

        if(action.actionId) formObject.onFormAction(action, null, null);
    }

    if(!pagingData)
        return(null)

    return (
        <DocPaging paging={pagingData} onPageChange={onPageChange} hidePageIfNR={true} />
    )
}

export default FormPaging